import React from "react";
import style from "./index.module.scss";
import { Divider, message, Tooltip } from "antd";
import Status from "../components/Status";
import { ExerciseItem, ExerciseStatus, getPaper } from "API/exercise";
import useDeviceType from "Utils/useDeviceType";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import classNames from "classnames";
import LinkButton from "../../../../../components/LinkButton";
import useRequestFn from "../../../../../Utils/useRequestFn";

interface ListItemProps {
    // data: ExerciseListItem;
    data: ExerciseItem;
    basename: string;
}

export default function ListItem({ data, basename }: ListItemProps) {
    const { isMobile } = useDeviceType();
    const history = useHistory();

    const [onCheck, { loading }] = useRequestFn(getPaper);

    async function check(exerciseId: number) {
        try {
            await onCheck(String(exerciseId));
            history.push(`${basename}/exercise/topics/${exerciseId}`);
        } catch (e) {
            message.info("请稍后点击");
        }
    }

    return (
        <div className={style.root}>
            <h1
                className={classNames(style.title, {
                    [style.mobileMaxWidth]:
                        isMobile && data.exerciseStatus.toString() !== "2"
                })}>
                <Tooltip
                    title={data.description}
                    placement={"topLeft"}
                    overlayClassName={style.tooltip}>
                    {data.description}
                </Tooltip>
                {!isMobile && (
                    <Status status={parseInt(data.studentExerciseStatus)} />
                )}
            </h1>

            {isMobile && data.exerciseStatus.toString() === "2" && (
                <span className={style.mobileEnd}>[活动已结束]</span>
            )}
            {isMobile && (
                <div>
                    <Status status={parseInt(data.studentExerciseStatus)} />
                </div>
            )}

            <div className={style.info}>
                {data.exerciseStatus.toString() === "2" && !isMobile && (
                    <span className={style.end}>[活动已结束]&nbsp;&nbsp;</span>
                )}
                {data.validityTime && (
                    <span>活动时长 {data.validityTime} 分钟</span>
                )}
                {!data.validityTime && <span>活动时长 不限</span>}
                {!isMobile && (
                    <Divider type="vertical" style={{ background: "#aaa" }} />
                )}
                <div className={style.time}>
                    <span>
                        开始时间 {moment(data.startTime).format("MM-DD HH:mm")}
                    </span>
                    &nbsp;&nbsp;
                    {data.endTime && (
                        <span>
                            结束时间{" "}
                            {moment(data.endTime).format("MM-DD HH:mm")}
                        </span>
                    )}
                </div>
            </div>

            {/* studentExerciseStatus: 0 未参与， 1 已参与。 exerciseStatus：0：未开始，1：进行中，2：已结束 */}
            <div className={style.tools}>
                {data.exerciseStatus.toString() === "1" &&
                    data.studentExerciseStatus.toString() ===
                        String(ExerciseStatus.Idle) && (
                        <LinkButton
                            onClick={() => check(data.id)}
                            loading={loading}>
                            前往参与
                        </LinkButton>
                    )}
                {data.exerciseStatus.toString() === "1" &&
                    data.studentExerciseStatus.toString() ===
                        String(ExerciseStatus.Done) && (
                        <span className={style.greylink}>
                            活动尚未结束，待活动结束后可查看练习详情
                        </span>
                    )}
                {data.exerciseStatus.toString() === "2" && (
                    <Link to={`${basename}/exercise/detail/${data.id}`}>
                        查看活动
                    </Link>
                )}
            </div>
        </div>
    );
}
